import AcceleratorDoc from "../AcceleratorDoc";
import API from "../API";
import { ExtractedTable, ExtractedTableDataDto } from "../ExtractedTable";
import { TableModel, TableModelData } from "../TableModel";

class RunTableReuse {
  docType: string;
  tableName: string;

  constructor(docType: string, tableName: string) {
    this.docType = docType;
    this.tableName = tableName;
  }

  async calculate(
    acceleratorDoc: AcceleratorDoc,
  ): Promise<RunTableReuseResponse | null> {
    return await API.get(`/v0/tablereuse/${acceleratorDoc.uuid}/generate`, {
      docType: this.docType,
      tableName: this.tableName,
    })
      .then((value: Response) => value.json())
      .then(
        (value: RunTableReuseResponseData) => new RunTableReuseResponse(value),
      )
      .catch((error: string) => {
        console.log(error);
        return null;
      });
  }
}

interface RunTableReuseResponseData {
  valid: boolean;
  reason: string;
  results: TableModelData[];
}
class RunTableReuseResponse {
  valid: boolean;
  reason: string;
  results: TableModelData[];

  constructor(data: RunTableReuseResponseData) {
    this.valid = data.valid;
    this.reason = data.reason;
    // TODO: populate properly
    this.results = data.results;
  }
}

export { RunTableReuse, RunTableReuseResponse };
